import { ApiManager } from './ApiManager';
import { CaregiverGroupDTO, CaregiverGroupWithOngoingConversationDTO } from './models/CaregiverGroupDTO';

export type ApiCaregiversManagerGetCaregiverGroupsListResult = CaregiverGroupDTO[];
export type ApiCaregiversManagerGetAvailableCaregiverGroupsListResult = CaregiverGroupDTO[];
export type ApiCaregiversManagerGetAvailableCaregiverGroupsForPatientParams = {
  patientId: string;
};
export type ApiCaregiversManagerGetAvailableCaregiverGroupsForPatientResult = CaregiverGroupDTO[];

export default class ApiCaregiversManager {
  static async getCaregiverGroupsList(): Promise<ApiCaregiversManagerGetCaregiverGroupsListResult> {
    const apiManager = ApiManager.getInstance();

    const response = await apiManager.get(`/api/caregiver-groups/`);

    return response.data;
  }

  static async getAvailableCaregiverGroupsList(): Promise<ApiCaregiversManagerGetAvailableCaregiverGroupsListResult> {
    const apiManager = ApiManager.getInstance();

    const response = await apiManager.get(`/api/caregiver-groups/available/`);

    return response.data;
  }

  static async getAvailableCaregiverGroupsForPatient(
    params: ApiCaregiversManagerGetAvailableCaregiverGroupsForPatientParams,
  ): Promise<CaregiverGroupWithOngoingConversationDTO[]> {
    const apiManager = ApiManager.getInstance();

    const response = await apiManager.get(`/api/caregiver-groups/available_for_patient/${params.patientId}/`);

    return response.data;
  }

  static async getCaregiverMe(): Promise<{ is_first_line_of_responders: boolean }> {
    const apiManager = ApiManager.getInstance();
    const response = await apiManager.get('/api/registered-caregivers/me/');
    return response.data;
  }
}
